module.exports = __webpack_public_path__ + "static/media/general-de-seguros-icon-noneOption.adfb5807.svg";